import { useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { toast } from 'react-toastify';
import { apiFetchAdmin } from '../hooks/apiFetch';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FCM_API_KEY,
    authDomain: process.env.REACT_APP_FCM_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FCM_DATABASE_URL,
    projectId: process.env.REACT_APP_FCM_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FCM_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FCM_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FCM_APP_ID,
    measurementId: process.env.REACT_APP_FCM_MEASUREMENT_ID
};

const MsgGetToken = () => {
    const [, setToken] = useState(null);

    useEffect(() => {
        const app = initializeApp(firebaseConfig);
        const messaging = getMessaging(app);

        //Send token to server
        const sendTokenToServer = async (token) => {
            try {
                const response = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/notifications/register-fcm-token`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ fcmToken: token }),
                });
                if (response && response.data && response.data.message) {
                    console.log(`FCM Token registered: ${response.data.message}`);
                }
            } catch (error) {
                console.error('Error sending token to server:', error);
                // toast.info(`Error Notifi: ${error}`)
            }
        };

        Notification.requestPermission()
            .then((permission) => {
                if (permission === 'granted') {
                    getToken(messaging, { vapidKey: process.env.REACT_APP_FCM_VAPID_KEY })
                        .then((newToken) => {
                            setToken(newToken);
                            // console.log('Token:', newToken);
                            sendTokenToServer(newToken);
                        })
                        .catch((error) => {
                            console.error('Error getting token:', error);
                        });
                } else {
                    console.error('Permission denied');
                    toast.info(`Permission denied`);
                }
            })
            .catch((error) => {
                console.error('Error requesting permission:', error);
                //toast.info(`Error Notifi: ${error}`);
            });

        // Listen for incoming messages
        const unsubscribe = onMessage(messaging, (payload) => {
            const { title, body } = payload.notification;

            if (Notification.permission === 'granted') {
                new Notification(title, { body });
                const audio = new Audio('/sounds/alert.mp3');
                audio.play().catch((err) => {
                    console.error('Audio play failed:', err);
                    // toast.warn(`Audio play failed: ${err}`);
                });
            }
            toast.info(`${title}: ${body}`);

            // Play sound using Audio API
        });
        return () => {
            unsubscribe();
        };
    }, []);
    return (null);
};

export default MsgGetToken;
